/// Get the endpoint for our Infura project
export const infuraHTTPEndpoint = (): string => {
  const networkName = process.env.REACT_APP_NETWORK_NAME;
  const projectId = process.env.REACT_APP_INFURA_PROJECT_ID;
  return `https://${networkName}.infura.io/v3/${projectId}`;
};
